import { useCallback, useEffect, useState } from 'react';
import { TrimUiManager } from '../../../trim-editor/manager/ui/trim.ui.manager';

type Props = {
  range: number,
  callback: (n: number) => void,
  min?: number,
  max?: number,
}
const RangeSlider = (props: Props) => {
  const { min = 0, max = 100, callback, range = 50 } = props;

  const onChangeRange = useCallback((v: number) => {
    callback(v);
  }, []);

  // 初期値がリセットされた場合に対応
  // useEffect(() => {
  //   setRange(defaultRange);
  // }, [defaultRange]);

  return (
    <div className="range_slider">
      <input type="range" min={min} max={max} value={range} onChange={(e) => onChangeRange(Number(e.target.value))} />
    </div>
  )
}

export default RangeSlider
